import React, { useEffect, useState } from 'react';
const START_SECONDS = 59 * 60 + 59;
function pad(value: number) {
  return value.toString().padStart(2, '0');
}
export function UrgencyBar() {
  const [remaining, setRemaining] = useState(START_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 0 ? 0 : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  return <div className="sticky top-0 z-50 w-full border-b border-carbon-line bg-carbon-800" data-id="element-216" data-mp="2u2lpxg369kwe">
      <div className="mx-auto flex max-w-content flex-col items-center gap-x-6 gap-y-1 px-4 py-2.5 text-center sm:flex-row sm:justify-between sm:px-6 sm:text-left" data-id="element-217" data-mp="2p5vbex70mxd3">
        <p className="text-[13px] text-paper" data-id="element-218" data-mp="2f6cqoeja77jz">
          <span className="font-bold uppercase tracking-[0.14em] text-mint" data-id="element-219" data-mp="2f98n1yfhdo6b">Flash sale</span> Full
          pack + 5 bonuses for 95% off — only $27. Ends tonight.
        </p>
        <p className="shrink-0 text-[13px] font-semibold tabular-nums text-mint" data-id="element-220" data-mp="1rvzq78zawlup">
          <span className="mr-2 text-[11px] uppercase tracking-[0.18em] text-paper-dim" data-id="element-221" data-mp="1wostdsf4fm4o">
            Ends in
          </span>
          {pad(hours)}:{pad(minutes)}:{pad(seconds)}
        </p>
      </div>
    </div>;
}